import { selectors } from 'app-webtech-core';
import { videoPlayerSizesSelector } from 'app-modules/player/selectors/playerSizes';

import { GOOG_PAL_UPDATED } from './types';
import { getNonce, newRequest } from '../../../utils/nonceLoader';

const ALLOWED_MARKETS = ['us', 'latam'];

export const applicationGoogPalRequest = (props) => async (dispatch, getState) => {
  const state = getState();
  const marketRegion = selectors.playbackSession.properties(state).marketingRegion;
  const includeGooglePalNonce = selectors.application.includeGooglePalNonce(state);
  if(!includeGooglePalNonce || !ALLOWED_MARKETS.includes(marketRegion)) return false;
  const {playerHeight: videoHeight, playerWidth: videoWidth} = videoPlayerSizesSelector(state);
  let googPalNonce;
  try {
    const request = newRequest({
      ...props,
      videoHeight,
      videoWidth,
    });
    const nonce = await getNonce(request);
    googPalNonce = nonce.b;
  } catch (e) {
    googPalNonce = false;
  }
  dispatch({ type: GOOG_PAL_UPDATED, payload: googPalNonce });

  return false;
};
